'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LinkContextProvider: function() {
        return LinkContextProvider;
    },
    linkContextDefaultValue: function() {
        return linkContextDefaultValue;
    },
    useLinkContext: function() {
        return useLinkContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const LinkContext = /*#__PURE__*/ _react.createContext(undefined);
const linkContextDefaultValue = {
    inline: false
};
const LinkContextProvider = LinkContext.Provider;
const useLinkContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(LinkContext)) !== null && _React_useContext !== void 0 ? _React_useContext : linkContextDefaultValue;
};
